// @flow
import { withStyles } from '@phg/stilo-toolbox/components';
import createField from 'app/hoc/createField';
import l  from 'app/Translate';
import { Input } from './base';
import { addressSecond } from './name';

const makeStyle = () => ({
    OptionalHelper: {
        position: 'relative'
    },
    Optional: {
        fontStyle: 'italic',
        position: 'absolute',
        top: 0,
        left: 165,
        lineHeight: '31px'
    }
});

const AddressSecondField = createField(addressSecond, () => ({
    id: 'AddressSecond',
    type: 'text',
    label: l('Address 2'),
    placeholder: l('Enter'),
    optional: true,
    optionalLabel: l('Optional')
}))(withStyles(makeStyle)(Input));

export default AddressSecondField;
